export default __webpack_public_path__ + "static/media/theatre.53bd83da.svg";